"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.catalogsImpressionsPixel = exports.catalogImpressionPixel = void 0;
var Utils_1 = require("./lib/Utils");
var ViewportMonitor_1 = require("./lib/ViewportMonitor");
var statsApi_1 = require("./lib/statsApi");
var config_1 = require("./config");
var commonProperties_1 = require("./lib/commonProperties");
var _1 = require(".");
var ImpressionCatalogStats = /** @class */ (function () {
    function ImpressionCatalogStats(getCookie, setCookie) {
        var _this = this;
        this._newContainer = function (container) {
            var view = container.getAttribute('data-view');
            if (!view) {
                console.warn('Found impression container without [data-view]. Please check your html.');
                return;
            }
            _this._registerView(view);
        };
        this._registerView = function (view) {
            if (_this.Views[view]) {
                console.warn("View [" + view + "] is duplicated. Please check your html");
                return;
            }
            var _a = config_1.getStatsData(), SearchCity = _a.SearchCity, Origin = _a.Origin, Platform = _a.Platform, SearchWord = _a.SearchWord, Integration = _a.Integration, PageType = _a.PageType, SearchType = _a.SearchType, VariantName = _a.VariantName;
            var URL_STATS_API = config_1.getConfiguration().URL_STATS_API;
            var apiController = new statsApi_1.default(URL_STATS_API);
            apiController.InitializeCatalogsImpression({
                SearchCity: SearchCity,
                SearchWord: SearchWord,
                Platform: Platform,
                Origin: Origin,
                Provider: Origin,
                View: view,
                PageType: PageType,
                SearchType: SearchType,
                IntegrationName: Integration,
                VariantName: VariantName
            });
            _this.Views[view] = apiController;
        };
        this._pushImpression = function (item, container) {
            //@ts-ignore
            var _a = item.dataset, id = _a.id, position = _a.position, modelname = _a.modelname, pagen = _a.pagen;
            var CatalogId = parseInt(id);
            var Position = parseInt(position);
            var ModelName = modelname === undefined ? "" : modelname;
            var PageNumber = pagen === undefined ? "" : pagen;
            if (!Utils_1.isNumber(Position) || !Utils_1.isNumber(CatalogId)) {
                if (!item.classList.contains('advertising')) {
                    console.warn('Error processing print element');
                    console.warn(item);
                }
                return;
            }
            //@ts-ignore
            var view = container.dataset.view;
            var apiController = _this.Views[view];
            if (apiController) {
                apiController.PushCatalog({
                    CatalogId: CatalogId,
                    Position: Position,
                    ModelName: ModelName,
                    PageNumber: PageNumber,
                    getCookie: _this.$getCookie,
                    setCookie: _this.$setCookie
                });
            }
        };
        this.Views = [];
        this.$getCookie = getCookie;
        this.$setCookie = setCookie;
        this.ViewportMonitor = new ViewportMonitor_1.default({
            containerClass: 'js-print-container',
            itemClass: 'js-print-item',
            onNewContainer: this._newContainer,
            onNewItem: this._pushImpression
        });
    }
    return ImpressionCatalogStats;
}());
exports.default = ImpressionCatalogStats;
exports.catalogImpressionPixel = function (catalogId, position, page, modelName, view, baseUrl) {
    return exports.catalogsImpressionsPixel([catalogId], [position], [page], [modelName], view, baseUrl);
};
exports.catalogsImpressionsPixel = function (catalogIds, positions, pages, modelNames, view, baseUrl) {
    var _a = config_1.getStatsData(), SearchCity = _a.SearchCity, SearchWord = _a.SearchWord, PageType = _a.PageType, Platform = _a.Platform, Origin = _a.Origin, Provider = _a.Provider, SearchType = _a.SearchType, Integration = _a.Integration;
    var entity = {
        CatalogIds: catalogIds,
        CatalogPositions: positions,
        CatalogPages: pages,
        CatalogModelNames: modelNames,
        PageType: "AMP_" + PageType,
        View: view,
        SearchType: SearchType,
        Provider: Provider,
        Origin: Origin,
        Integration: Integration,
        Platform: Platform || _1.Device.Mobile,
        SearchCity: encodeURIComponent(SearchCity),
        SearchWord: encodeURIComponent(SearchWord),
        UserToken: commonProperties_1.getUserTokenAMP(),
        ClientTimeStamp: commonProperties_1.getFormattedClientTimeStamp(),
        TimeZoneOffset: commonProperties_1.getTimezoneOffset()
    };
    return baseUrl + "/Catalog/Print/Pixel?entity=" + JSON.stringify(entity);
};
//# sourceMappingURL=catalog-impression.js.map